module.exports = __webpack_public_path__ + "img/type2_check1.343f5192.png";